export default {
    mutations: {
        lock({ curComponent }) {
            console.log(curComponent);
            curComponent.isLock = true
        },

        unlock({ curComponent }) {
            curComponent.isLock = false
        },
    },
}